import React from 'react';
import bedShapeOne from '../images/ui_buttons/bed_shape_1_button.png';
import bedShapeTwo from '../images/ui_buttons/bed_shape_2_button.png';
import bedShapeThree from '../images/ui_buttons/bed_shape_3_button.png';
import bedShapeFour from '../images/ui_buttons/bed_shape_4_button.png';
import bedShapeFive from '../images/ui_buttons/bed_shape_5_button.png';
import bedShapeSix from '../images/ui_buttons/bed_shape_6_button.png';
import bedShapeSeven from '../images/ui_buttons/bed_shape_7_button.png';
import bedShapeEight from '../images/ui_buttons/bed_shape_8_button.png';
import bedShapeNine from '../images/ui_buttons/bed_shape_9_button.png';
// bed-pipeline:shape-imports (new shape imports are inserted above this line by bed:generate)
import { useAppContext, SET_SHAPE, SET_BED_SIZE } from '../context/AppContext';
import { availableShapes, availableSizes, nextBedSize, sizeLabel } from '../lib/bedAvailability';

// One row per selectable bed shape. bed:generate appends a row (and the matching import)
// when a brand-new shape is generated — keep the marker comments in place.
const SHAPE_BUTTONS = [
	{ id: 'bed_shape_1', image: bedShapeOne, alt: 'Bed Shape 1' },
	{ id: 'bed_shape_2', image: bedShapeTwo, alt: 'Bed Shape 2' },
	{ id: 'bed_shape_3', image: bedShapeThree, alt: 'Bed Shape 3' },
	{ id: 'bed_shape_4', image: bedShapeFour, alt: 'Bed Shape 4' },
	{ id: 'bed_shape_5', image: bedShapeFive, alt: 'Bed Shape 5' },
	{ id: 'bed_shape_6', image: bedShapeSix, alt: 'Bed Shape 6' },
	{ id: 'bed_shape_7', image: bedShapeSeven, alt: 'Bed Shape 7' },
	{ id: 'bed_shape_8', image: bedShapeEight, alt: 'Bed Shape 8' },
	{ id: 'bed_shape_9', image: bedShapeNine, alt: 'Bed Shape 9' },
	// bed-pipeline:shape-rows (new rows are inserted above this line by bed:generate)
];

const shapeNum = (id) => parseInt(id.replace('bed_shape_', ''), 10);

const GardenBedButtons = ({ selectedShape, selectedBedSize }) => {
	const { state, dispatch } = useAppContext();
	const style = state.currentDesign?.style;
	const visibleShapes = SHAPE_BUTTONS.filter((s) => availableShapes(style).includes(s.id));

	// Logic for choosing selected garden bed shape
	const handleSelectGardenShape = (shapeId) => {
		console.log('GardenBedButtons received click on', shapeId);
		dispatch({ type: SET_SHAPE, payload: shapeId });
		// Clear a size the new shape doesn't have; auto-select a sole option.
		dispatch({ type: SET_BED_SIZE, payload: nextBedSize(shapeId, style, selectedBedSize) });
	};

	// Logic for choosing selected garden bed size
	const handleSelectGardenSize = (sizeId) => {
		console.log('GardenBedButtons received click on', sizeId);
		dispatch({ type: SET_BED_SIZE, payload: sizeId });
	};

	const renderShapeButton = (shape) => (
		<button
			key={shape.id}
			className={`bed-shape-button ${selectedShape === shape.id ? 'selected' : ''}`}
			onClick={() => handleSelectGardenShape(shape.id)}>
			<img src={shape.image} alt={shape.alt} className='bed-shape-icon' />
		</button>
	);

	return (
		<div className='left-side-button-container'>
			<h2>Choose your garden bed shape and size</h2>
			<div className='bed-shape-container'>
				<h3>Bed Shape</h3>
				<div className='bed-shape-button-container'>
					<div className='bed-shape-column'>
						{visibleShapes.filter((s) => shapeNum(s.id) % 2 === 1).map(renderShapeButton)}
					</div>
					<div className='bed-shape-column'>
						{visibleShapes.filter((s) => shapeNum(s.id) % 2 === 0).map(renderShapeButton)}
					</div>
				</div>
			</div>
			<div className='bed-size-container'>
				<h3>Bed Size</h3>
				{availableSizes(selectedShape, style).map((size) => (
					<button
						key={size}
						className={`bed-size-button ${selectedBedSize === size ? 'selected' : ''}`}
						onClick={() => handleSelectGardenSize(size)}>
						{sizeLabel(selectedShape, size, style)}
					</button>
				))}
			</div>
		</div>
	);
};

export default GardenBedButtons;
